import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

const initData = {
    reservation_id: '',
    comment: '',
};

function ShipOrder({ modal, setModal, id, getData }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData })

    const [reservations, setReservations] = useState([])

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST('/inventory/ship-fg/', sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData });
            getData();
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }


    useEffect(() => {
        async function getReservations() {
            const response = await GET(`/inventory/reservations/?product_id=${id}`)
            if (httpOk(response)) {
                setReservations(response.data)
            }
        }

        if (modal && id) {
            getReservations()
        }
    }, [modal, id]);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('ship')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('ship_reserved_order')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('reservations')}</label>
                        <CustomSelect
                            options={reservations}
                            value={reservations?.find(option => option.id === sendData?.reservation_id) || ''}
                            getOptionLabel={(option) => `${option.product_name} [${option.quantity}]`}
                            onChange={(option) => setSendData({ ...sendData, reservation_id: option?.id })}
                            placeholder={t('select_reservation')}
                        />
                    </div>

                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('additional_info')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('ship')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default ShipOrder